import {
    Component,
    EventEmitter,
    Inject,
    OnDestroy,
    OnInit
} from '@angular/core';
import {
    Router,
    NavigationEnd
} from '@angular/router';

import {
    MasterComponentService
} from './shared/services/master-component.service';
import {
    AuthenticationService
} from './shared/services/authentication.service';
import {
    RealTimeService
} from './shared/services/realtime.service';

import {
    ImageModalService
} from './shared/services/image-modal.service';
import {
    LocalizePipe
} from './shared/pipes/Localize.pipe';
import {
    Configuration
} from './shared/configurations/shared.config';
import {
    ResourceService
} from './shared/services/resource.service';
import {
    RoutingAuthenticationService
} from './shared/services/routing-authentication';

import * as jQuery from 'jquery';
import {
    ImageModal
} from './shared/components/imageModal/image-modal.component';
import {
    UserControlServiceService
} from './shared/services/user-control-access.service';
import {
    IErrorHandler,
    IErrorHandlerToken,
    CookiesEnum
} from './shared/dataModels';
import {
    CookiesService
} from './shared/services/cookies.service'
import {
    Subscription
} from 'rxjs';
import { SignalRCoreNotificationService } from './shared/services/signalRCore-notification.service';
// declare var jQuery: any;

@Component( {
    moduleId: module.id,
    selector: 'app',
    templateUrl: 'app.component.html'
} )
export class App implements OnInit, OnDestroy {
    //staffPanicRole: number;

    openModalWindow: boolean = false;
    imagePointer: number;
    images: any[] = [];
    currentStaff: any = {};
    IsAdmin: boolean = true
    AppDirection = "ltr";
    tabsClosed = new EventEmitter < void > ();
    pageUrlSubscription: any = null;
    isAdminPage: boolean = true;
    isChrome: boolean;
    currentYear: any=new Date().getFullYear();

    get isLogged() {
        return this.auth.isLogged;
    }


    get allowedPages() {
        return this.routerAuth.allowedPages;
    }

    subscriptions: Subscription[] = [];

    constructor( private _signalr: RealTimeService, private _router: Router,
        public _masterComponentService: MasterComponentService, private _cookie: CookiesService,
        private auth: AuthenticationService,
        private _imageModalService: ImageModalService,
        private routerAuth: RoutingAuthenticationService, 
        private signalRCoreService: SignalRCoreNotificationService,
        @Inject( IErrorHandlerToken ) private _errorHandler: IErrorHandler ) {

        if ( _cookie.getCookieByKey( CookiesEnum.UserPreference ) == "ar" ) {
            this.AppDirection = 'rtl';
        } else {
            this.AppDirection = 'ltr';
        }

        this.subscriptions.push( this._imageModalService.openModalRequest.subscribe( metadata => {
            this.OpenImageModel( metadata.imageSrc, metadata.images );
        } ) );

        auth.validUser();

        this.subscriptions.push( auth.loggedIn.subscribe( meta => {
            // // console.log( "auth.loggedIn.subscribe", this.currentStaff.IsAdmin );
            if ( this.currentStaff && this.currentStaff.IsAdmin )
                this.isAdminPage = true;
                this.IsAdmin = true;
            this.loadCurrentStaff();
            // // console.log( "this.currentStaff", this.currentStaff )
        } ) );

        this.subscriptions.push( auth.loggedOut.subscribe( () => {
            if ( this._signalr && this._signalr.connectionExists ) {
                this._signalr.unload();
            }
            if ( this.pageUrlSubscription != null ) {
                this.pageUrlSubscription.unsubscribe();
                this.pageUrlSubscription = null;
            }
            if ( this.currentStaff.IsAdmin )
                this.isAdminPage = true;
                this.IsAdmin = true;
            this.currentStaff = {}
            this.IsAdmin = false;

            this.auth.staffData.next(null);
            // console.log( "this.currentStaff", this.currentStaff )
        } ) );
        this.currentStaff.IsAdmin = true;
        this.IsAdmin = true;
        this._router.events.subscribe( ( val ) => {
            this._masterComponentService.closeRigthBar();
        } );


        this.checkChrome();
    }

    checkChrome() {
        switch ( true ) {
            case window.navigator.userAgent.toLowerCase().indexOf( "edge" ) > -1:
                return this.isChrome = false;
            case window.navigator.userAgent.toLowerCase().indexOf( "edg/" ) > -1:
                return this.isChrome = false;
            case window.navigator.userAgent.toLowerCase().indexOf( "opr" ) > -1:
                return this.isChrome = false;
            case window.navigator.userAgent.toLowerCase().indexOf( "chrome" ) > -1:
                return this.isChrome = true;
            case window.navigator.userAgent.toLowerCase().indexOf( "trident" ) > -1:
                return this.isChrome = false;
            case window.navigator.userAgent.toLowerCase().indexOf( "firefox" ) > -1:
                return this.isChrome = false;
            case window.navigator.userAgent.toLowerCase().indexOf( "safari" ) > -1:
                return this.isChrome = false;
            default:
                return this.isChrome = false;
        }
    };

    async ngOnInit() {
        if ( this.auth.checkIsLogged() ) {
            this.loadCurrentStaff();
        }
        //this.getPanicStaffRoleForCurrentStaff();
        // console.log( "this.currentStaff", this.currentStaff )
        this.auth.staffData.subscribe( result => {
            // console.log( "this.auth.staffData.subscribe", result );
            this.currentStaff = result;
          
            // this.currentStaff.IsAdmin = false;
            if ( this.currentStaff && this.currentStaff.IsAdmin ) {
                // console.log( "in if: this.currentStaff && this.currentStaff.IsAdmin" );
                this.IsAdmin = this.currentStaff.IsAdmin;
                this.pageUrlSubscription = this._router.events.filter( event => event instanceof NavigationEnd ).subscribe( urlObj => {
                    // console.log( "urlObj", urlObj );

                    if ( urlObj[ "url" ] && urlObj[ "url" ] != "/" ) {
                        // console.log( 'urlObj["url"] && urlObj["url"] != "/"', urlObj[ "url" ] && urlObj[ "url" ] != "/" );

                        this.isAdminPage = urlObj[ "urlAfterRedirects" ] == '/adminlanding/welcome' ? true : false;
                    }
                } );
                // console.log( "this.currentStaff", this.currentStaff )
            } else {
                // console.log( "in else" );
                this.isAdminPage = false;
                this.IsAdmin = false;
                // console.log( "this.currentStaff", this.currentStaff )
            }
        } );
    }

    private loadCurrentStaff(): void {
        // console.log( "loadCurrentStaff" );
        this.auth.getStaffData();


    }

    onInfoBarClick() {

    }

    onSideBarClick() {
        this._masterComponentService.toggleLeftBar();

        //var sideBarCollapsed = document.body.classList.item(1);

        //if (!sideBarCollapsed) {
        jQuery( ".wrapper" ).toggleClass( "expanded collapsed" );
        //}
        //else {
        //    jQuery(".wrapper").toggleClass("expanded collapsed", 900);
        //}
    }

    onHeaderBarClick( event: any ) {
        this._masterComponentService.OpenHeaderBar( event );
    }

    onFullScreenClicked() {
        this._masterComponentService.OpenFullScreenMode();
    }




    OpenImageModel( imageSrc, images ) {
        var imageModalPointer;
        for ( var i = 0; i < images.length; i++ ) {
            if ( imageSrc === images[ i ].img ) {
                imageModalPointer = i;
                break;
            }
        }
        this.openModalWindow = true;
        this.images = images;
        this.imagePointer = imageModalPointer;
    }

    cancelImageModel() {
        this.openModalWindow = false;
    }

    redirectToNotificationSettings() {
        this.tabsClosed.emit();
        //this._router.navigateByUrl(Configuration.paths.notificationSettings);
    }

    logout() {
        this.auth.logout().then( r => {
            this.closeSignalrConnections();
            this._router.navigateByUrl( Configuration.paths.loginUrl );
        } );
    }

    closeSignalrConnections(){
        this.signalRCoreService.closeNormaOrderConnection();
        this.signalRCoreService.closeWorkOrderConnection();
        this.signalRCoreService.closeUserConnection();
    }

    ngOnDestroy() {
        this.subscriptions.forEach( item => item.unsubscribe() );
    }

}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/app.component.ts